import React from 'react';
import { useContent } from '../i18n/LanguageContext';
import { MapPin } from 'lucide-react';

export default function FieldGallery() {
  const c = useContent();
  const g = c.gallery;
  // Bento spans for a dynamic layout (6 images)
  const spans = [
    'md:col-span-2 md:row-span-2 h-64 md:h-full',
    'h-64 md:h-auto',
    'h-64 md:h-auto',
    'h-64 md:h-auto',
    'h-64 md:h-auto',
    'md:col-span-2 h-64 md:h-auto',
  ];
  return (
    <section id="gallery" className="py-14 md:py-20 bg-slate-50">
      <div className="lt-container">
        <div className="max-w-3xl reveal">
          <p className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-widest text-teal-600">
            <MapPin className="w-4 h-4" /> {g.eyebrow}
          </p>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-bold text-slate-900 leading-tight">{g.title}</h2>
          <p className="mt-4 text-lg text-slate-600">{g.subtitle}</p>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 md:auto-rows-[200px] gap-4">
          {g.images.map((src, i) => (
            <div
              key={i}
              className={`reveal group relative rounded-2xl overflow-hidden border border-slate-200 ${spans[i] || 'h-64 md:h-auto'}`}
              style={{ animationDelay: `${(i % 6) * 70}ms` }}
            >
              <img src={src} alt={g.captions[i]} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/75 via-slate-900/10 to-transparent opacity-90" />
              <div className="absolute bottom-0 inset-x-0 p-4 translate-y-1 group-hover:translate-y-0 transition-transform">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-white/15 backdrop-blur px-3 py-1 text-xs font-semibold text-white border border-white/20">
                  <span className="h-1.5 w-1.5 rounded-full bg-teal-400" /> {g.captions[i]}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
